function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { useCallback } from 'react';
/**
 * Gets an item's position in a list of items based on its row index in a table.
 * @param table Table to search for the item in
 * @param columnName Column name to search for the item in
 * @param defaultValue Optional default value. This would be the first item in
 * the list and not expected to be in the Table.
 * @param itemHeight Height of each item in the list
 * @param topOffset Optional pixel offset from the top of the list
 * @param value Value to search for in the column
 */
export function useGetItemPosition(_ref) {
  var table = _ref.table,
    columnName = _ref.columnName,
    defaultValue = _ref.defaultValue,
    itemHeight = _ref.itemHeight,
    _ref$topOffset = _ref.topOffset,
    topOffset = _ref$topOffset === void 0 ? 0 : _ref$topOffset,
    value = _ref.value;
  return useCallback(/*#__PURE__*/_asyncToGenerator(function* () {
    if (table == null || value === '' || value === defaultValue) {
      return topOffset;
    }
    var column = table.findColumn(columnName);
    var rowIndex = yield table.seekRow(0, column, 'String', value);

    // If a default item exists at the top of the list, offset the item index by 1
    var defaultItemOffset = defaultValue == null ? 0 : 1;
    return (rowIndex + defaultItemOffset) * itemHeight + topOffset;
  }), [columnName, defaultValue, itemHeight, table, topOffset, value]);
}
export default useGetItemPosition;
//# sourceMappingURL=useGetItemPosition.js.map